"use client"
import { Button, Select, Tag, Input } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import CloseIcon from "../icons/CloseIcon"
import { FILTER_FIELD_OPTIONS, TOPIC_OPTIONS, PROPOSAL_TOPIC_OPTIONS ,PROPOSAL_TOPIC_OPTIONS_NO_TEMPLATE } from "../../utils/constants"
import { useLocation } from "react-router-dom"

const { Option } = Select

// 多种操作符
const operatorOptions = ["等于", "不等于"]

const FilterCard = ({ config, onConfigChange, onNext }) => {
  const location = useLocation();
  const isProposalPage = location.pathname === '/explore/proposals';
  // 移除会导致意外更新的 useEffect

  // 添加新条件 - 默认选topic
  const addCondition = () => {
    const defaultField = 'tags';
    const newCondition = {
      field: defaultField,
      operator: operatorOptions[0],
      values: [],
      value: undefined,
      id: Date.now().toString(),
    }
    const updatedConditions = [...(config.conditions || []), newCondition];
    onConfigChange({
      ...config,
      conditions: updatedConditions,
    });
  }

  // 移除条件
  const removeCondition = (id) => {
    const conditions = Array.isArray(config.conditions) ? config.conditions : [];
    onConfigChange({
      ...config,
      conditions: conditions.filter((condition) => condition.id !== id),
    })
  }

  // 更新条件字段
  const updateConditionField = (id, field) => {
    const conditions = Array.isArray(config.conditions) ? config.conditions : [];
    onConfigChange({
      ...config,
      conditions: conditions.map((condition) =>
        condition.id === id ? {
          ...condition,
          field,
          operator: field === 'create_by' ? undefined : operatorOptions[0],
          values: [],
          value: undefined
        } : condition
      ),
    })
  }

  // 更新条件操作符
  const updateConditionOperator = (id, operator) => {
    const conditions = Array.isArray(config.conditions) ? config.conditions : [];
    onConfigChange({
      ...config,
      conditions: conditions.map((condition) => (condition.id === id ? { ...condition, operator } : condition)),
    })
  }

  // 更新条件值
  const updateConditionValues = (id, values) => {
    const conditions = Array.isArray(config.conditions) ? config.conditions : [];
    onConfigChange({
      ...config,
      conditions: conditions.map((condition) => {
        if (condition.id === id) {
          let finalValues = values || [];
          
          return {
            ...condition,
            values: finalValues,
            value: finalValues && finalValues.length === 1 ? finalValues[0] : finalValues
          };
        }
        return condition;
      }),
    })
  }

  // 更新创建者输入
  const updateCreatorValue = (id, value) => {
    const conditions = Array.isArray(config.conditions) ? config.conditions : [];
    onConfigChange({
      ...config,
      conditions: conditions.map((condition) => (
        condition.id === id ? {
          ...condition,
          values: value ? [value] : [],
          value: value
        } : condition
      )),
    })
  }

  const conditions = Array.isArray(config.conditions) ? config.conditions : [];

  return (
    <div>
      <div className="filter-card-header">
        <h3 className="filter-card-title">设置筛选条件</h3>
      </div>
      <div className="filter-card-content">
        {conditions.length === 0 ? (
          <div className="text-xs text-gray-400 mb-4">暂无条件，请点击“新条件”添加</div>
        ) : null}
        {conditions.map((condition) => (
          <div key={condition.id} className="filter-condition">
            {/* 字段选择 */}
            <div className="filter-condition-field">
              <Select
                value={condition.field}
                onChange={(value) => updateConditionField(condition.id, value)}
                style={{ width: "100%" }}
              >
                {([{ label: '场景', value: 'tags' }, ...FILTER_FIELD_OPTIONS.filter(option => option.value !== 'tags')]).map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.value === 'tags' && isProposalPage ? '场景' : option.label}
                  </Option>
                ))}
              </Select>
            </div>
            {/* 操作符，仅创建者不显示 */}
            {condition.field !== 'create_by' && (
              <div className="filter-condition-operator">
                <Select
                  value={condition.operator}
                  onChange={(value) => updateConditionOperator(condition.id, value)}
                  style={{ width: "100%" }}
                >
                  {operatorOptions.map((option) => (
                    <Option key={option} value={option}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </div>
            )}
            {/* 值选择/输入 */}
            <div className="filter-condition-value">
              {condition.field === 'tags' ? (
                <Select

                  value={condition.values || []}
                  onChange={(values) => {
                    updateConditionValues(condition.id, values);
                  }}
                  style={{ width: "100%" }}
                  placeholder={isProposalPage ? "请选择场景" : "请选择话题"}
                  optionFilterProp="children"
                  showSearch
                >
                  {isProposalPage ? PROPOSAL_TOPIC_OPTIONS_NO_TEMPLATE.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  )) : TOPIC_OPTIONS.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              ) : (
                // 创建者为输入框
                <Input
                  value={condition.value || ''}
                  onChange={e => updateCreatorValue(condition.id, e.target.value)}
                  placeholder="请输入创建者名称"
                />
              )}
            </div>
            <div className="filter-condition-remove" onClick={() => removeCondition(condition.id)}>
              <CloseIcon />
            </div>
          </div>
        ))}

        <a className="filter-add-condition absolute bottom-1" onClick={addCondition}>
          <PlusOutlined /> 新条件
        </a>

        <div className="filter-actions">
          <Button type="primary" className="filter-next-btn" onClick={onNext}>
            下一项
          </Button>
        </div>
      </div>
    </div>
  )
}

export default FilterCard
